
import { Col, Row } from "reactstrap";
import React from "react";
// import Bags from "./bagsDash";
import CaseFiles from "./caseFiles";

const Home = () => {

    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    {/* <Bags /> */}
                    <CaseFiles isDashboard={true} />
                </Col>
            </Row>
        </React.Fragment>
        
    )
    
}

export default Home;

